<template>
  <!-- Page Content -->
  <div class="hero-static">
    <div class="content">
      <b-row class="justify-content-center">
        <b-col md="8" lg="6" xl="4">
          <!-- Sign In Block -->
          <base-block
            rounded
            themed
            header-class="bg-primary-dark"
            class="mb-0"
            title="Sign In"
          >
            <div class="text-center">
              <img src="../../../assets/logo.png" width="20%" />
            </div>
            <div class="p-sm-3 px-lg-4 py-lg-4">
              <h1 class="h2 mb-1">Aptitude Buster</h1>
              <!-- Sign In Form -->
              <b-form @submit.stop.prevent="onSubmit">
                <div class="py-3">
                  <div class="form-group">
                    <b-form-input
                      size="lg"
                      class="form-control-alt"
                      id="username"
                      name="username"
                      autocomplete="off"
                      placeholder="Username"
                      v-model="form.username"
                    ></b-form-input>
                  </div>
                  <div class="form-group">
                    <b-form-input
                      type="password"
                      size="lg"
                      class="form-control-alt"
                      id="password"
                      name="password"
                      autocomplete="off"
                      placeholder="Password"
                      v-model="form.password"
                    ></b-form-input>
                  </div>
                  <div></div>
                  <div style="color: red" v-if="loginErrors">
                    {{ loginErrors }}
                  </div>
                </div>
                <b-row class="form-group">
                  <b-col md="6" xl="5">
                    <b-button type="submit" variant="alt-primary" block>
                      <i class="fa fa-fw fa-sign-in-alt mr-1"></i> Sign In
                    </b-button>
                  </b-col>
                </b-row>
              </b-form>
              <!-- END Sign In Form -->
            </div>
          </base-block>
          <!-- END Sign In Block -->
        </b-col>
      </b-row>
    </div>
    <div class="content content-full font-size-sm text-muted text-center">
      <strong>{{ $store.getters.appName }}</strong> &copy;
      {{ $store.getters.appCopyright }}
    </div>
  </div>
  <!-- END Page Content -->
</template>

<script>
export default {
  data() {
    return {
      form: {
        username: "",
        password: "",
      },
    };
  },
  computed: {
    loginErrors() {
      return this.$store.getters.loginErrors;
    },
  },
  mounted() {
    console.log("login rendered");

    // var objappVersion = navigator.appVersion;
    var browserAgent = navigator.userAgent;
    var browserName = navigator.appName;
    var browserVersion = "" + parseFloat(navigator.appVersion);
    var browserMajorVersion = parseInt(navigator.appVersion, 10);
    var Offset, OffsetVersion, ix;

    // For Chrome
    if ((OffsetVersion = browserAgent.indexOf("Chrome")) != -1) {
      browserName = "Chrome";
      browserVersion = browserAgent.substring(OffsetVersion + 7);
    }

    // For Microsoft internet explorer
    else if ((OffsetVersion = browserAgent.indexOf("MSIE")) != -1) {
      browserName = "Microsoft Internet Explorer";
      browserVersion = browserAgent.substring(OffsetVersion + 5);
    }

    // For Firefox
    else if ((OffsetVersion = browserAgent.indexOf("Firefox")) != -1) {
      browserName = "Firefox";
    }

    // For Safari
    else if ((OffsetVersion = browserAgent.indexOf("Safari")) != -1) {
      browserName = "Safari";
      browserVersion = browserAgent.substring(OffsetVersion + 7);
      if ((OffsetVersion = browserAgent.indexOf("Version")) != -1)
        browserVersion = browserAgent.substring(OffsetVersion + 8);
    }

    // For other browser "name/version" is at the end of userAgent
    else if (
      (Offset = browserAgent.lastIndexOf(" ") + 1) <
      (OffsetVersion = browserAgent.lastIndexOf("/"))
    ) {
      browserName = browserAgent.substring(Offset, OffsetVersion);
      browserVersion = browserAgent.substring(OffsetVersion + 1);
      if (browserName.toLowerCase() == browserName.toUpperCase()) {
        browserName = navigator.appName;
      }
    }

    // Trimming the fullVersion string at
    // semicolon/space if present
    if ((ix = browserVersion.indexOf(";")) != -1)
      browserVersion = browserVersion.substring(0, ix);
    if ((ix = browserVersion.indexOf(" ")) != -1)
      browserVersion = browserVersion.substring(0, ix);

    browserMajorVersion = parseInt("" + browserVersion, 10);
    if (isNaN(browserMajorVersion)) {
      browserVersion = "" + parseFloat(navigator.appVersion);
      browserMajorVersion = parseInt(navigator.appVersion, 10);
    }
    console.log("Name of Browser = " + browserName);
    console.log("Full version = " + browserVersion);
    console.log("Major version = " + browserMajorVersion);
    console.log("navigator.appName = " + navigator.appName);
    console.log("navigator.userAgent = " + navigator.userAgent);
  },
  methods: {
    onSubmit() {
      let username = this.form.username;
      let password = this.form.password;
      this.$store.dispatch("login", { username, password });
    },
  },
};
</script>
